const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the change buddy component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('changeBuddy', ['Users', function(Users) {
  return {
    restrict: 'E',
    scope: {
      user: '=',
      immediateInit: '=',
      update: '&'
    },
    template: require('../../templates/directives/change-buddy.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.showHide = false;

      self.optionRestrictions = {
        locations: true,
        departments: true,
        teams: true,
        org_levels: true,
        grades: true,
        skills: true
      };

      self.onQuery = function(query) {
        Users.get({subresource: query._id, fields: 'first_name,last_name,full_name,email'}).$promise
        .then(function(user) {
          $scope.update({email: user.email});
        });
      };

      if ($scope.immediateInit) {
        self.showHide = true;
        $scope.immediateInit = false;
      }

    }],
    controllerAs: 'editBuddy'
  };
}]);
